import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import DisableDevtool from 'disable-devtool';
import { noDebugger } from '@/config/index';

import { useRoute } from 'vue-router';
import { onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'App'
  },
  __name: 'App',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const route = useRoute();
    onMounted(() => {
      // 是否允许生产环境进行代码调试，请前往config/cli.config.ts文件配置
      setTimeout(() => {
        if (!location.hostname.includes('127') && !location.hostname.includes('localhost') && (location.hostname.includes('beautiful') || location.hostname.includes('vuejs-core') || noDebugger) && route.query && route.query.debugger !== 'auto') DisableDevtool({
          url: 'https://vuejs-core.cn/debugger',
          timeOutUrl: 'https://vuejs-core.cn/debugger'
        });
      }, 500);
    });
    const __returned__ = {
      route
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});